import { atom, useAtomValue } from 'jotai';

/**
 * Atoms backing the generated example note shown in the template review
 * preview. Persisting them across mounts means the example isn't
 * regenerated when the user navigates away from (and back to) the
 * template-review step.
 */

/** Last generated example note content (markdown). null before first generation. */
export const onboardingExampleNoteAtom = atom<string | null>(null);

/**
 * Template structure the current `onboardingExampleNoteAtom` value was
 * generated for. Used by `useTemplateReviewState` to decide whether to
 * regenerate when the structure changes.
 */
export const onboardingExampleNoteForTemplateAtom = atom<string | null>(null);

/** True while an example note generation request is in flight. */
export const onboardingExampleNoteGeneratingAtom = atom(false);

/**
 * Read-only accessor for whether the onboarding example note is currently
 * being generated. Used by `TemplateReviewStep` to disable the Continue
 * button so users can't navigate away mid-generation (which used to leave
 * the preview stuck in a loading state on return).
 */
export function useIsOnboardingExampleNoteGenerating(): boolean {
  return useAtomValue(onboardingExampleNoteGeneratingAtom);
}
